<script>
  import { translate } from "../lib/translate";

    export let visible = false;
    export let hide = () => {};
    export let vehicle = {};

    let formHtml;

    if (typeof window !== 'undefined') {

        formHtml = document.createElement('div');
        formHtml.classList.add('contact-form-wrapper');
        formHtml.innerHTML = document?.querySelector('.wpcf7')?.outerHTML;

        let refWrapper = formHtml?.querySelector("span[data-name=ref-no]")
        let refInput = refWrapper?.querySelector('input');
        let label = document.createElement('label');
        const icon = document.createElement('svg');
        icon.classList.add('btn-arrow');
        icon.setAttribute('fill', '#fff');
        icon.setAttribute('width', 11);
        icon.setAttribute('height', 11);
        icon.innerHTML = `
            <path d="M10.8242 5.07253L6.85169 1.09996C6.73829 0.98656 6.58715 0.924316 6.426 0.924316C6.26467 0.924316 6.11362 0.986649 6.00022 1.09996L5.63955 1.46072C5.52624 1.57394 5.46382 1.72516 5.46382 1.88641C5.46382 2.04756 5.52624 2.20388 5.63955 2.3171L7.95704 4.63969H0.594263C0.262298 4.63969 0 4.89958 0 5.23163V5.74165C0 6.0737 0.262298 6.35979 0.594263 6.35979H7.98333L5.63964 8.69535C5.52633 8.80875 5.46391 8.95586 5.46391 9.1171C5.46391 9.27817 5.52633 9.42742 5.63964 9.54073L6.00031 9.90033C6.11371 10.0137 6.26476 10.0755 6.42609 10.0755C6.58724 10.0755 6.73838 10.0129 6.85178 9.89953L10.8243 5.92704C10.9379 5.81328 11.0004 5.66143 11 5.50001C11.0003 5.33805 10.9379 5.18611 10.8242 5.07253Z" />
        `;
        let submitBtn = formHtml?.querySelector('.form-group.submit-btn');
        submitBtn?.appendChild(icon);

        label.innerHTML = 'Ref.No:';
        refInput?.setAttribute('value', vehicle.refNo);
        refWrapper?.prepend(label);
    }

    if(visible){
        console.log("trigger");
        wpcf7?.init(document?.querySelector(".content .wpcf7-form"))
    }

</script>

<div class="wrapper" id="contact-form-lagerhofbestand" style={`display: ${visible ? "block" : "none"}`}>
    <div class="bg"></div>
    <div class="contact-modal">
        <div class="close" on:click={hide}>x</div>
        <div class="vehicle-details">
            <img src={vehicle.image} alt={vehicle.name} height="205" />
            <h3>{vehicle.name}</h3>
        </div>
        <div class="content">
            <h3>{@html translate('Kontaktieren sie uns, <br />um das Angebot zu besprechen.')}</h3>
            {@html formHtml.innerHTML}
        </div>
    </div>
</div>

<style type="text/scss" lang="scss" global>
    .form-group .form-control.wpcf7-not-valid{
        border-color: red !important;
    }
    body > .wpcf7 {
        display: none;
    }
    span.ref-no {
        position: relative;
        label {
            position: absolute;
            line-height: 32px;
            font-weight: 700;
        }
        input {
            text-indent: 54px;
        }
    }
    #contact-form-lagerhofbestand {
        .wpcf7#wpcf7-f10-o1 {
            display: block;
        }
        &.wrapper {
            width: 100vw;
            height: 100%;
            top: 0;
            left: 0;
            position: fixed;
            z-index: 999999;

            .bg {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                background-color: #000000;
                opacity: .8;
            }
        }
        .contact-modal {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 9999999;
            background-color: var(--c-primary);
            display: flex;
            color: white;
            @media (max-width: 899px) {
                flex-direction: column;
                width: calc(100% - 30px);
                margin: 0 auto;

                .vehicle-details,
                .content {
                    width: 100%;
                }
            }
        }
        .vehicle-details {
            width: 305px;
            padding: 0 39px 0 22px;
            display: flex;
            flex-direction: column;
            justify-content: center;

            @media (max-width: 899px) {
                padding: 0;
            }

            h3 {
                font-size: 20px;
                font-weight: 700;
                line-height: 22px;
                margin-top: 22px;
                padding: 0 18px 10px;
            }
        }

        .content {
            width: 542px;
            padding-top: 40px;
            padding-right: 50px;
            padding: 40px 50px 55px 0;
            position: relative;

            @media (max-width: 899px) {
                padding: 15px 28px 35px 18px;
            }

            h3 {
                font-size: 30px;
                font-weight: 700;
                line-height: 29px;
                margin-bottom: 30px;

                @media (max-width: 899px) {
                    display: none;
                }
            }
        }

        .grid {
            display: flex;
            flex-wrap: wrap;
            > * {
                flex-grow: 1;
            }
        }

        .input-group {
            position: relative;

            label {
                position: absolute;
                top: 0px;
                line-height: 29px;
                font-weight: 700;
                font-size: 14px;
                left: 18px;
            }

            input {
                text-indent: 55px;
                margin-right: 0;
            }
        }

        input[type=text],
        input[type=email],
        input[type=tel],
        textarea {
            background-color: transparent !important;
            border: 0;
            border-bottom: solid 1px #fff;
            font-style: italic;
            color: white;
            font-size: 14px;
            &::placeholder {
                color: white;
            }
        }

        .form-group {
            &:not(.textarea-box):not(:first-child):not(.submit-btn) {
                flex-basis: calc(50% - 13px);
            }
            &.textarea-box {
                flex-basis: 100%;
                margin-bottom: 0;
            }
            input:not([type="submit"]),
            textarea {
                padding-left: 0;
            }
            &:nth-of-type(2),
            &:nth-of-type(4) {
                margin-right: 26px;
            }
        }

        input[type=text],
        input[type=email],
        input[type=tel] {
            height: 34px;
            border-radius: 0px;
        }

        .form-group.submit-btn .svg,
        .form-group.submit-btn .wpcf7-spinner {
            display: none;
        }

        .form-group.submit-btn {
            padding-top: 0;
        }

        textarea {
            height: 127px;
            margin-bottom: 19px;
        }

        .form-group:first-child {
            flex-basis: 100%;
        }

        .button {
            display: inline-block;
        }

        :global(body.admin-bar .wrapper) {
            height: calc(100% - 32px);
            top:32px;
        }

        .submit {
            width: 101px;
        }

        
        .btn-arrow {
            position: absolute;
            right: 12px;
            top: calc(50% - 6px);
            transform: translateY(-50%);
        }

        .close {
            position: absolute;
            top: 12px;
            right: 20px;
            color: white !important;
            font-size: 40px;
            line-height: 1em;
            cursor: pointer;
            z-index: 10000;

            @media (max-width: 899px) {
                top: -50px;
            }
        }

    }
</style>
